import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import {getBaseResources} from './i18n/resources/index.js';
import {NS} from './i18n/namespaces.js';

const resources = getBaseResources();

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  resources,
  ns: Object.values(NS),
  defaultNS: NS.ALL,
  fallbackNS: Object.values(NS),
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18n;
